import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingPage, PressItemTrackingEvent, TrackingEventName, TrackingEventCategory } from "./tracking";

interface PressItemFunctionArgs {
  readonly checkoutItemId: string;
}
interface PressItemFunction {
  (args: PressItemFunctionArgs): void;
}

interface UseTrackPressItemFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly checkoutId: string | undefined;
  readonly tradename: Tradename;
}
interface UseTrackPressItemFunction {
  (agrs: UseTrackPressItemFunctionArgs): PressItemFunction;
}

const useTrackPressItem: UseTrackPressItemFunction = ({ page, country, segment, checkoutId, tradename }) => {
  const emitUserEvent = useEmitUserEvent<PressItemTrackingEvent>();

  const pressItem: PressItemFunction = useCallback(
    ({ checkoutItemId }) => {
      if (!checkoutId) {
        return;
      }

      const pressItemTrackingEvent: PressItemTrackingEvent = {
        event: TrackingEventName.PRESS_ITEM,
        eventCategory: TrackingEventCategory.NAVIGATION,
        section: `${PROJECT}_${page}`,
        store: country,
        segment,
        checkoutId,
        tradename,
        checkoutItemId,
      };

      emitUserEvent(pressItemTrackingEvent);
    },
    [checkoutId, tradename, country, emitUserEvent, page, segment],
  );

  return pressItem;
};

export { useTrackPressItem };
